import { useState } from 'react';

export function useSessionStorage<T>(key: string, initialValue: T): [T, (value: T) => void] {
    // Get value from session storage or use provided initial value
    const storedValue = sessionStorage.getItem(key);
    const initialState = storedValue ? JSON.parse(storedValue) : initialValue;

    // Create state to store the value
    const [value, setValue] = useState<T>(initialState);

    // Update local storage and state when the value changes
    function updateValue(newValue: T): void {
        setValue(newValue);
        sessionStorage.setItem(key, JSON.stringify(newValue));
    }

    return [value, updateValue];
}
